import React, {  useCallback, useEffect }  from "react"
import { useDispatch, useSelector } from "react-redux"
import useHistoryState from "../useHistoryState"
import {  RootReducer } from "../app/reducer"



export type OptionCl = {
    id: string,
    description: string
}

 type Props = {
    id? : string
    name: string
    options?: OptionCl[]
    label?: string
    explain?: JSX.Element
    reset? : number
}


export const SelectCl : React.FC<Props> = props  => {
    const windowHistoryState : any = useSelector((state:RootReducer) =>  state.searchHistoryReducer.searchHistoryState );
    const options = props.options ? props.options : []
    const initialValue = "---";
    const [selectedValue, setSelectedValue] = useHistoryState(props.name, initialValue);

    useEffect(() => {               
        if (props.reset !== 0) {
            setSelectedValue(initialValue);            
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.reset])
    
    //The below useEffect is used to maintain history when moving between pages
    useEffect(() => {                               
        if (windowHistoryState && windowHistoryState[props.name]) {
            setSelectedValue(windowHistoryState[props.name]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowHistoryState])

    const rootDispatch = useDispatch();

    const toggleState = useCallback (() => { 
        if (props.explain ) {
            rootDispatch( {type:"App/EXTWINDOWOPEN", content: props.explain})
        }
    },[rootDispatch,props.explain])

    return(
        <div className="search-table-row">
            <span className={props.explain ? 'search-table-col-left navigation' : 'search-table-col-left'} onClick={ toggleState }>{props.label}</span>
            <span className="search-table-col-right">
                <select id={props.id} name={props.name} value={selectedValue} onChange={e => setSelectedValue(e.target.value)}>
                    <option key={`---any${props.name}`} value="---">Any</option>
                    {options.map( option => <option key={option.id+option.description} value={option.id}>{option.description}</option>)}                    
                </select>
            </span>
            
        </div>
    )


}

